import { TFunction } from 'i18next';
import { filterUndefinedRows } from 'src/js/pages/statistic/statistic-mapper';
import { StatisticSectionViewModel } from 'src/js/pages/statistic/statistic-view-model';
import { toTitleCase } from 'src/js/util/global-util';
import { formatUptime } from '../stream/stream-helper';

import { MetadataViewModel, metadataStateToName } from './metadata-models';

export const mapMetadataToStatistics = (metadata: MetadataViewModel, t: TFunction): StatisticSectionViewModel[] => {
  const relays = () => {
    const rows: any = [];
    metadata.stats.relays?.map((relay, index) => {
      return rows.push(
        {
          name: t('metadata.statistics.relayStatistics', { count: index + 1 }),
          value: ' ',
        },
        {
          name: t('metadata.statistics.relayedBytes'),
          value: relay.relayedBytes,
          className: 'hai-pl-6',
        },
        {
          name: t('metadata.statistics.relayedMessages'),
          value: relay.relayedMessages,
          className: 'hai-pl-6',
        },
        {
          name: t('metadata.statistics.relayingErrors'),
          value: relay.relayingErrors,
          className: 'hai-pl-6',
        },
        {
          name: t('metadata.statistics.lastRelayError'),
          value: relay.lastRelayError,
          className: 'hai-pl-6',
        },
        {
          name: t('metadata.statistics.lastRelayErrorOccurred'),
          value: relay.lastRelayErrorOccurred,
          className: 'hai-pl-6',
        },
      );
    });

    return rows;
  };

  const stats = [
    {
      title: t('statistics.header.statistics'),
      rows: [
        {
          name: t('general.status'),
          value: toTitleCase(metadataStateToName(metadata.state, t), false),
        },
        {
          name: t('metadata.statistics.rxBytes'),
          value: metadata.stats.rxBytes,
        },
        {
          name: t('metadata.statistics.rxOKMessages'),
          value: metadata.stats.rxOKMessages,
        },
        {
          name: t('metadata.statistics.rxCorruptMessages'),
          value: metadata.stats.rxCorruptMessages,
        },
        {
          name: t('metadata.statistics.klvBitrate'),
          value: `${metadata.stats.klvBitrate} kbps`,
        },
        {
          name: t('metadata.statistics.rxSPIMessages'),
          value: metadata.stats.rxSPIMessages,
        },
        {
          name: t('metadata.statistics.rxAirCraftMessages'),
          value: metadata.stats.rxAirCraftMessages,
        },
        {
          name: t('metadata.statistics.generatedKLVMessages'),
          value: metadata.stats.generatedKLVMessages,
        },
        {
          name: t('metadata.statistics.generatedKLVBytes'),
          value: metadata.stats.generatedKLVBytes,
        },
        {
          name: t('metadata.statistics.rxFilteredSPIMessages'),
          value: metadata.stats.rxFilteredSPIMessages,
        },
        {
          name: t('metadata.statistics.rxUasMessages'),
          value: metadata.stats.rxUasMessages,
        },
        {
          name: t('metadata.statistics.invalidUasMessages'),
          value: metadata.stats.invalidUasMessages,
        },
        {
          name: t('metadata.statistics.addedMissionIDs'),
          value: metadata.stats.addedMissionIDs,
        },
        {
          name: t('metadata.statistics.updatedMissionIDs'),
          value: metadata.stats.updatedMissionIDs,
        },
        {
          name: t('metadata.statistics.addedSecuritySets'),
          value: metadata.stats.addedSecuritySets,
        },
        {
          name: t('metadata.statistics.updatedSecuritySets'),
          value: metadata.stats.updatedSecuritySets,
        },
        {
          name: t('metadata.statistics.sourceTOS'),
          value: metadata.stats.sourceTOS,
        },
        {
          name: t('metadata.statistics.tosChanges'),
          value: metadata.stats.tosChanges,
        },
        {
          name: t('metadata.statistics.lastTosChange'),
          value: metadata.stats.lastTosChange,
        },
        {
          name: t('metadata.statistics.sourceTTL'),
          value: metadata.stats.sourceTTL,
        },
        {
          name: t('metadata.statistics.ttlChanges'),
          value: metadata.stats.ttlChanges,
        },
        {
          name: t('metadata.statistics.lastTtlChange'),
          value: metadata.stats.lastTtlChange,
        },
        {
          name: t('statistics.stream.rows.lastReset'),
          value: formatUptime(metadata.stats.lastReset),
        },
      ].concat(relays()),
    },
  ];

  return filterUndefinedRows(stats);
};
